import type {
    HolisticSummaryCategory,
    Provider,
    SpendAccountCategory,
} from '@fruitful/types';

import { requestBuilder } from '../../http/RequestBuilder';
import type { GeneralResponse } from '../../http/types/Common';

interface UseRecategorizeAccountBody {
    accountId: string;
    holisticCategory: HolisticSummaryCategory;
    spendAccountCategory?: SpendAccountCategory;
    provider: Provider;
}

const useRecategorizeAccount = requestBuilder.mutation<
    GeneralResponse,
    UseRecategorizeAccountBody
>({
    endpoint: '/api/holistic/recategorize',
    method: 'PATCH',
});

export default useRecategorizeAccount;
